import { render } from "./EspecialidadesPrestador.vue?vue&type=template&id=992c40f6&scoped=true"
import script from "./EspecialidadesPrestador.vue?vue&type=script&lang=js"
export * from "./EspecialidadesPrestador.vue?vue&type=script&lang=js"

import "./EspecialidadesPrestador.vue?vue&type=style&index=0&id=992c40f6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992c40f6"]])

export default __exports__